//ZakritieZasedaniyaPravleniyaFederatsii
import React, {  } from 'react';
import { DatePicker, Form, Input } from 'antd';


import locale from 'antd/es/date-picker/locale/ru_RU';

export default function ZakritieZasedaniyaPravleniyaFederatsii(props) {
    const { object } = props;
    // const [city, setCity] = useState([]);

    // useEffect(() => {
    //     auth.fetch('/api/query/City?s-name').then(res => {
    //         if (res && res.data) {
    //             setCity(res.data);
    //         }
    //     });
    // }, []);

    // const options = city.map(i => (
    //     <Option key={i.ID} value={i.ID}>{i.name}</Option>
    // ));
    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{
                zasedaniePravleniyaFederatsiiID: object.ID 
            }}
        >
            <Form.Item
                preserve={"true"}
                hidden={true}
                name={"zasedaniePravleniyaFederatsiiID"}
                label={"Заседание правления федерации"}
                rules={[{ required: true, message: 'Укажите заседание правления федерации!' }]}
            >
                <Input disabled />
            </Form.Item>

            <Form.Item
                name={"dataOkonchaniyaZasedaniya"}
                label={"Дата окончания заседания"}
                rules={[{ required: true, message: 'Укажите дату окончания заседания!' }]}
            >
                <DatePicker locale={locale} />
            </Form.Item>
        </Form>
    );
}
